export default __webpack_public_path__ + "static/media/milton_santos.a859d263.jpg";